<template>
	<svg
		:alt="alt"
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g fill="none" fill-rule="evenodd">
			<path fill="#EEEBE9" d="M-511-634H929v3584H-511z"/>
			<path fill="#FFF" d="M-511-484H929V9803H-511z"/>
			<rect x="1" y="1" width="18" height="14" rx="2" transform="rotate(-90 17 9)" fill="#FFF" stroke="#00ABEF" stroke-width="2"/>
			<path fill="#00ABEF" d="M12 11h8v2h-8zm0 4h8v2h-8zm0 4h4v2h-4z"/>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
